import {fromGlobalId} from './fromGlobalId';

type Role = 'agent' | 'lead' | 'admin';

interface TicketLike {
	assignee_id: string | null;
}

// The session user id is the viewer's Person global id (`actualPersonId`), while
// queue tickets carry `assignee_id` already decoded to the raw person id (see
// `mapNodeToTicket`). Decode the user id to the same shape before comparing; a
// value that isn't a global id (standalone dev, tests) is kept as-is.
function toRawPersonId(userId: string): string {
	try {
		return fromGlobalId(userId);
	} catch {
		return userId;
	}
}

// Mirrors server enforcement: agents may only see tickets assigned to them on
// the board. Lead/admin see all queues. The server is the trust boundary;
// this is purely UX scoping.
export function scopeBoardTickets<T extends TicketLike>(tickets: T[], role: Role, userId: string): T[] {
	if (role !== 'agent') return tickets;
	const ownIds = new Set([userId, toRawPersonId(userId)]);
	return tickets.filter(t => t.assignee_id !== null && ownIds.has(t.assignee_id));
}
